import React, {Component} from 'react';

class Header extends Component {
    render() {
        return (
            <h1 className="heading">  Restaurants</h1>
        );
    }
}

export default Header;